import { Icon } from 'ui';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ChatButton from '../ChatButton';
import ChatDropdown from '../ChatDropdown';
import './ConversationHistory.scss';

const NOOP = () => {};

function ConversationHistory({
  conversations = [],
  onSelectConversation = NOOP,
  onNewChat = NOOP,
  isLoading = false,
  error = null,
  isNewChatDisabled = false,
}) {
  const { t, i18n } = useTranslation(['chatbot']);

  // Format date with user's language
  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return date.toLocaleString(i18n.language, {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    } catch {
      return dateString;
    }
  };

  return (
    <ChatDropdown
      className="conversation-history"
      showFooter={true}
      footerContent={
        <ChatButton
          variant="outlined"
          color="brand"
          size="large"
          onClick={onNewChat}
          disabled={isNewChatDisabled}
          className="conversation-history__new-chat-button"
        >
          {t('New chat')}
        </ChatButton>
      }
    >
      {isLoading ? (
        <div className="conversation-history__loading">
          <div className="conversation-history__spinner" />
          <p>{t('Loading')}...</p>
        </div>
      ) : error ? (
        <div className="conversation-history__error">
          <Icon name="info-circle" size="md" color="red" />
          <p>{error}</p>
        </div>
      ) : conversations && conversations.length > 0 ? (
        <ul className="conversation-history__list">
          {conversations.map((conversation) => (
            <li key={conversation.id} className="conversation-history__item">
              <div className="conversation-history__item-wrapper">
                <button type="button" className="conversation-history__button" onClick={() => onSelectConversation(conversation.id)}>
                  <div className="conversation-history__info">
                    <div className="conversation-history__item-title">{conversation.title || t('Start a conversation')}</div>
                    <div className="conversation-history__metadata">
                      <span className="conversation-history__date">{formatDate(conversation.updatedAt)}</span>
                    </div>
                  </div>
                </button>
                {/* <ChatIconButton
                      icon="trash"
                      onClick={(e) => {
                        e.stopPropagation();
                        // Delete functionality will be implemented later
                      }}
                      size="small"
                      variant="error"
                      className="conversation-history__delete-button"
                      ariaLabel={t('Delete')}
                    /> */}
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <div className="conversation-history__empty">
          <p>{t('No conversations yet')}</p>
          <p className="conversation-history__empty-subtitle">{t('Start a new chat to begin!')}</p>
        </div>
      )}
    </ChatDropdown>
  );
}

ConversationHistory.propTypes = {
  conversations: PropTypes.array,
  onSelectConversation: PropTypes.func,
  onNewChat: PropTypes.func,
  isLoading: PropTypes.bool,
  error: PropTypes.string,
  isNewChatDisabled: PropTypes.bool,
};

export default ConversationHistory;
